import Controller from '@ember/controller';
import { service } from '@ember/service';

export default class MyProfileController extends Controller {
  @service
  session;
}
